<script>
  import { renderFailed } from './errorPolicy.js'

  export let component

  function _props(pp) {
    let { component, ...rest } = $$props
    return rest
  }
  $: props = _props($$props)

  // cc3-mew3.1: a lazy chunk that fails to load must never reach
  // `Cmp.default` as undefined, and must never reject out of {#await}.
  //
  // Two outcomes of a failed preload, and both are handled here:
  // - App.svelte's vite:preloadError listener reloads the page and calls
  //   preventDefault(), which makes Vite's helper RESOLVE the import to
  //   undefined. The reload is in flight: keep showing the loading state.
  // - The listener declines (reload cooldown, blocked storage), Vite rethrows,
  //   and the import rejects. Nothing will recover on its own, so hand the
  //   error to renderFailed instead of letting it escape as an unhandled
  //   rejection.
  function load(source) {
    let loading
    try {
      loading = Promise.resolve(source.then ? source : source())
    } catch (error) {
      loading = Promise.reject(error)
    }
    return loading.catch((error) => {
      renderFailed(error)
      return undefined
    })
  }
  $: loaded = load(component)
</script>

{#await loaded}
  Loading component...
{:then Cmp}
  {#if Cmp?.default}
    <svelte:component this="{Cmp.default}" {...props} />
  {:else}
    Loading component...
  {/if}
{/await}
